import { doc, getDoc } from "firebase/firestore";
import { db } from "@/firebase/config";

/**
 * Checks whether the given email is in the `admins` allowlist collection.
 *
 * Admin documents are keyed by the lowercase email address (the document
 * itself may be empty, we only check for its existence). Firebase Auth can
 * preserve the casing a user signed up with, so we normalize before lookup.
 *
 * @param email The authenticated user's email (may be null)
 * @returns Promise<boolean> true if the email is an allowed admin
 */
export const isAdminEmail = async (email: string | null | undefined): Promise<boolean> => {
  if (!email) return false;

  try {
    const adminRef = doc(db, "admins", email.toLowerCase());
    const snapshot = await getDoc(adminRef);
    return snapshot.exists();
  } catch (error) {
    console.error("Error checking admin allowlist:", error);
    // Fail closed: if we cannot verify, deny access.
    return false;
  }
};
